export var GxControlType;
(function (GxControlType) {
    GxControlType[GxControlType["EDIT"] = 1] = "EDIT";
    GxControlType[GxControlType["RADIO"] = 4] = "RADIO";
    GxControlType[GxControlType["COMBO"] = 5] = "COMBO";
    GxControlType[GxControlType["CHECK"] = 7] = "CHECK";
})(GxControlType || (GxControlType = {}));
export var GxControlDataType;
(function (GxControlDataType) {
    GxControlDataType[GxControlDataType["NUMBER"] = 0] = "NUMBER";
    GxControlDataType[GxControlDataType["CHAR"] = 1] = "CHAR";
    GxControlDataType[GxControlDataType["DATE"] = 2] = "DATE";
    GxControlDataType[GxControlDataType["DATETIME"] = 3] = "DATETIME";
    GxControlDataType[GxControlDataType["VARCHAR"] = 5] = "VARCHAR";
    GxControlDataType[GxControlDataType["LONGVARCHAR"] = 6] = "LONGVARCHAR";
    GxControlDataType[GxControlDataType["BOOLEAN"] = 7] = "BOOLEAN";
})(GxControlDataType || (GxControlDataType = {}));
//# sourceMappingURL=genexus.js.map
